import React from 'react';
import { Box, Typography, Card, CardContent, Grid, Avatar, Button } from '@mui/material';
import { useTheme, useMediaQuery } from '@mui/material';

const BannerCashback = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleClick = () => {
        window.open('/devolve', '_blank'); 
    };

    return (
        <Box sx={{ 
            backgroundColor: 'var(--c-brand-cashback)', 
            borderRadius: 2, 
            color: 'white', 
            maxWidth: 1290, 
            width: {xs: '94%', sm: '90%', lg: '90%'},
            mx: 'auto', 
            mt: 2, 
            height: '134px',             
            py: 2,   
            }}>
            <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-around', 
                flexDirection: { xs: 'column', sm: 'row' },
                mb: 3, 
                height: '100%', 
                width: '100%', 
                }}>
                {!isMobile && (
                    <img
                        src="https://static.meucupom.com/media/2026%20-%20Updates/Cashback_icon_negativo-01%20(1).png"
                        alt=""
                        style={{ width: 58 }}
                    />
                )}
                <Typography variant="h4" 
                sx={{
                    textTransform: 'uppercase',
                    fontSize: {
                    xs: '1.3rem', 
                    sm: '1.5rem', 
                    md: '2rem',   
                    },
                    fontWeight: 'bold',
                }}
                >
                    Melhores Cashbacks
                </Typography>
                <Button
                    variant="outlined"
                    size="medium"
                    onClick={handleClick}
                    sx={{
                        border: '2px solid white',
                        color: 'white',
                        backgroundColor: 'transparent',
                        textTransform: 'uppercase',
                        fontWeight: 'bold',
                        fontSize: '1rem',
                        padding: '8px 16px',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                        backgroundColor: '#ffffff',
                        color: 'var(--c-brand-cashback)', 
                        border: '2px solid #ffffff',
                        },
                    }}
                >
                Como funciona!?
                </Button>
            </Box>
        </Box>
    );
};

export default BannerCashback;
